import { type ModerationDataSource } from '../../data/moderation.data-source'
import { type ModerationFilterParams, type PaginatedMessages } from '../models/moderation.model'

export class GetReviewedMessagesInteractor {
  constructor(private readonly dataSource: ModerationDataSource) {}

  async execute(params?: Omit<ModerationFilterParams, 'needsAction'>): Promise<PaginatedMessages> {
    return this.dataSource.getLogs({ ...params, needsAction: false })
  }
}
